import { render } from "./EditMode.vue?vue&type=template&id=544d9eba"
import script from "./EditMode.vue?vue&type=script&lang=js"
export * from "./EditMode.vue?vue&type=script&lang=js"
script.render = render

export default script